import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { useMemo } from "react";
import { getCurrentSite } from "@/siteConfig";

import HomePage from "@/pages/HomePage";
import BauunternehmungPage from "@/pages/BauunternehmungPage";
import GalabauPage from "@/pages/GalabauPage";
import SachverstaendigerPage from "@/pages/SachverstaendigerPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import AGBPage from "@/pages/AGBPage";
import { CookieConsent } from "@/components/shared/CookieConsent";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";

const HOME_PAGES = {
  gruppe: HomePage,
  bauunternehmung: BauunternehmungPage,
  galabau: GalabauPage,
  sachverstaendiger: SachverstaendigerPage,
};

function App() {
  const site = useMemo(() => getCurrentSite(), []);
  const DomainHome = HOME_PAGES[site.id] || HomePage;

  return (
    <HelmetProvider>
    <BrowserRouter>
      <div className="min-h-screen flex flex-col bg-background text-foreground">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<DomainHome />} />
            <Route path="/bauunternehmung" element={<BauunternehmungPage />} />
            <Route path="/galabau" element={<GalabauPage />} />
            <Route path="/sachverstaendiger" element={<SachverstaendigerPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/agb" element={<AGBPage />} />
          </Routes>
        </main>
        <Footer />
        <CookieConsent />
        <Toaster />
      </div>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
